<template>
  <div id="PriceFunFood">
    <div class="container-fluid" >
      <div class="productwrap">
        <b-row >
          <b-col sm="4" lg="4" v-for="(od,oi) in data" :key="oi">
             <h5 class="cust-head" style="margin-top: 9px;color:#533a79!important;text-transform:capitalize;">  {{oi}}</h5>
            <div v-for="d in od" :key="oi+d.platform">
              <b-card style="border:none;" :class="d.platform + '_border'">
                <div class="leftsticker"  :class="d.platform + '_bg'">
                  {{ d.platform.slice(0,1).toUpperCase()  }}
                </div> 
                <div class="rightsticker">
                  <div class="name">
                    <a v-if="d.product_link" target="_blank" :href="d.product_link">{{ d.platform }} </a>
                    <span v-else >{{ d.platform }} </span>
                  </div>
                  <div class="value" :class="d.platform + '_color'">
                    <i class="fa fa-rupee" v-if="d.price!='N/A'&&d.product_link" ></i> 
                    {{ d.price }}
                    <span v-if="d.quantity"> ({{ d.quantity }})</span>
                    <div class="outofstock" v-if="d.out_of_stock">Out of stock</div>
                  </div>
                </div>  
              </b-card>
            </div>  
          </b-col>
          <!-- <b-col sm="3" lg="3" >
            <b-card style="border:none;border-right: 2px solid #533a79;">
              <div class="leftsticker" style="background:#533a79;">
                <i class="fa fa-clock-o"></i>
              </div> 
              <div class="rightsticker">
                <div class="name">Last updated on</div>
                <div class="value" style="color:#533a79;">{{ moment(timestamp).format('DD MMM YYYY HH:mm') }} </div>
              </div>  
            </b-card>
          </b-col> -->
        </b-row>  
      </div>  
    </div>
  </div>
</template>

<script> 
import moment from 'moment'
import datecomponent from './date.vue'

export default {
  name: 'PriceFunFood',
  components: {
    datecomponent
  },
  data: function () {
    return {
      data: {},
      moment:moment,
      timestamp: "2021-02-03 12:00:00"
    }
  },
  mounted()
  {
    this.refresh()
  },
  methods: {
    refresh(){
      this.data  = {
        'funfoods peanut butter': [
          {
            out_of_stock: false,
            platform: "amazon",
            price: "149.00",
            product_link: "https://www.amazon.in/Funfoods-Peanut-Butter-Creamy-340g/dp/B00O8X9RVI/",
            quantity: "400 g",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "flipkart",
            price: "230.00",
            product_link: "https://www.flipkart.com/fun-foods-peanut-butter-creamy-400gm-400-g/p/itme28f3770fe024?pid=JASFZBYYGSSUX3FR&lid=LSTJASFZBYYGSSUX3FRHQYREM&marketplace=FLIPKART&srno=s_1_17&otracker=AS_QueryStore_OrganicAutoSuggest_1_17_na_na_ps&otracker1=AS_QueryStore_OrganicAutoSuggest_1_17_na_na_ps&fm=SEARCH&iid=de084f45-4786-4113-9204-fca86773962a.JASFZBYYGSSUX3FR.SEARCH&ppt=sp&ppn=sp&ssid=l6pebt4k280000001612172459108&qH=82601202c395c801",
            quantity: "400 g",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "grofers",
            price: "169.00",
            product_link: "https://grofers.com/prn/dr.-oetker-funfoods-creamy-peanut-butter/prid/105480",
            quantity: "340 g",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: true,
            platform: "bigbasket",
            price: "275.00",
            product: "ghadi detergent powder",
            product_link: "https://www.bigbasket.com/pd/40028998/dr-oetker-funfoods-peanut-butter-creamy-925-g/?nc=cl-prod-list&t_pg=&t_p=&t_s=cl-prod-list&t_pos=1&t_ch=desktop",
            quantity: "925 g",
            timestamp: "2020-08-19 12:00:00"
          }
        ],
        'pintola all natural peanut butter': [
          {
            out_of_stock: false,
            platform: "amazon",
            price: "378.00",
            product_link: "https://www.amazon.in/dp/B06XFSSDNH/",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "flipkart",
            price: "349.00",
            product_link: "https://www.flipkart.com/pintola-all-natural-export-quality-peanut-butter-crunchy-1-kg/p/itmf6gsmdanwwn5g?pid=JASFYBHBBMTSJCTB&lid=LSTJASFYBHBBMTSJCTBMJULYF&marketplace=GROCERY&spotlightTagId=BestsellerId_eat%2Fxhv&srno=s_1_3&otracker=search&otracker1=search&fm=SEARCH&iid=e678271d-d9ee-469b-bba8-bd4bad211a6d.JASFYBHBBMTSJCTB.SEARCH&ppt=sp&ppn=sp&ssid=1e4wrbstfk0000001612172245628&qH=102d51d07445ed45",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "grofers",
            price: "N/A",
            product_link: "",
            quantity: "",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: true,
            platform: "bigbasket",
            price: "980.00",
            product_link: "https://www.bigbasket.com/pd/40127455/pintola-all-natural-peanut-butter-unsweetened-crunchy-25-kg/?nc=cl-prod-list&t_pg=&t_p=&t_s=cl-prod-list&t_pos=1&t_ch=desktop",
            quantity: "2.5 kg",
            timestamp: "2020-08-19 12:00:00"
          }
        ],
        'alpino natural peanut butter': [
          {
            out_of_stock: false,
            platform: "amazon",
            price: "384.00",
            product_link: "https://www.amazon.in/Alpino-Natural-Peanut-Butter-Unsweetened/dp/B077S4V3V9/",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "flipkart",
            price: "344.00",
            product_link: "https://www.flipkart.com/alpino-classic-peanut-butter-crunch-1-kg-made-roasted-peanuts-25-protein-non-gmo-gluten-free-vegan/p/itmab0806aca85d9?pid=JASF2SKYNYDSMBNE&lid=LSTJASF2SKYNYDSMBNEVDCYTL&marketplace=FLIPKART&srno=s_1_1&otracker=search&otracker1=search&fm=SEARCH&iid=en_ModD6tqVQSfLDcD6JCVUO6IXOjWy%2BRDjw4fTlWhR3eeNrAS%2B6jukCrekZHP1fS%2B5vqWxtQ31%2B%2Bo%2FX0WSR%2FenTw%3D%3D&ppt=sp&ppn=sp&qH=102d51d07445ed45",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "grofers",
            price: "N/A",
            product_link: "",
            quantity: "",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: true,
            platform: "bigbasket",
            price: "425.00",
            product_link: "https://www.bigbasket.com/pd/40145304/alpino-natural-peanut-butter-smooth-unsweetenedgluten-free-non-gmovegan-1-kg/",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }
        ],
        'disano peanut butter': [
          {
            out_of_stock: false,
            platform: "amazon",
            price: "260.00",
            product_link: "https://www.amazon.in/Disano-Peanut-Butter-Crunchy-Jar/dp/B07JNF7R7X/",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "flipkart",
            price: "238.00",
            product_link: "https://www.flipkart.com/disano-peanut-butter-crunchy-350-g/p/itmfbhwbguzvqvvh?pid=JASFBHWBHPNJZFUY&lid=LSTJASFBHWBHPNJZFUYQDZ4X8&marketplace=GROCERY&srno=s_1_1&otracker=search&otracker1=search&fm=SEARCH&iid=e2623881-b96e-4451-b56f-9ce050977198.JASFBHWBHPNJZFUY.SEARCH&ppt=sp&ppn=sp&ssid=zjh1gqyy7k0000001612172424068&qH=619a7a2c5bdef461",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: true,
            platform: "grofers",
            price: "235.00",
            product_link: "https://grofers.com/prn/disano-crunchy-peanut-butter-jar/prid/442170",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: true,
            platform: "bigbasket",
            price: "500.00",
            product_link: "https://www.bigbasket.com/pd/40159679/disano-unsweetened-peanut-butter-100-natural-crunchy-1-kg-jar/?nc=cl-prod-list&t_pg=&t_p=&t_s=cl-prod-list&t_pos=1&t_ch=desktop",
            quantity: "1 kg",
            timestamp: "2020-08-19 12:00:00"
          }
        ],
        'muscleblaze high protein peanut butter': [
          {
            out_of_stock: false,
            platform: "amazon",
            price: "399.00",
            product_link: "https://www.amazon.in/MuscleBlaze-Protein-Peanut-Butter-Chocolate/dp/B08GKC17MT/",
            quantity: "750 g",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "flipkart",
            price: "399.00",
            product_link: "https://www.flipkart.com/muscleblaze-high-protein-natural-peanut-butter-750-g/p/itmfcgughw593zr9?pid=JASFCHAWFYTRBF8C&lid=LSTJASFCHAWFYTRBF8C49DRKE&marketplace=FLIPKART&srno=s_1_5&otracker=search&otracker1=search&fm=SEARCH&iid=e678271d-d9ee-469b-bba8-bd4bad211a6d.JASFCHAWFYTRBF8C.SEARCH&ppt=sp&ppn=sp&qH=102d51d07445ed45",
            quantity: "750 g",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "grofers",
            price: "N/A",
            product_link: "",
            quantity: "",
            timestamp: "2020-08-19 12:00:00"
          }, {
            out_of_stock: false,
            platform: "bigbasket",
            price: "N/A",
            product_link: "",
            quantity: "",
            timestamp: "2020-08-19 12:00:00"
          }
        ]
      };
      // let url = "/api/reviews/recentprice"
      // this.$http.get(url).then(response => {
      //   this.data = response.data.data  
      //   console.log(this.data) 
      // }, err => {
      //   console.log('error')
      // });
    },
  }
}
</script>
<style scoped>
 .name
 {
    line-height: 28px;
    text-transform: capitalize;
    font-size: 19px;
    margin-left: 10px;
 }
 .value
 {
    font-size: 16px;
    line-height: 24px;
    margin-left: 11px;
 }
 .leftsticker
 {
    width: 65px;
    float: left;
    height: 54px;
    color: white;
    font-size: 37px;
    text-align: center;
 }
 .rightsticker
 {
    width: 100%;
    float: left;
    background:#f7f7f7;
 }
 .card
 {
   margin-bottom:8px
 }
 .card-body
 {
  padding:0!important;
  display:flex;
 }
 .productwrap
 {
    background: white;
    padding: 26px;
    padding-top:6px;
    margin-top: 6px;
 }
 .grofers_color
 {
  color:#f15c2c;
 }
 .grofers_border
 {
  border-right: 2px solid #f15c2c!important;
 }
 .grofers_bg
 {
    background: url(/img/grofers.png)!important;
    background-repeat: round!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 }
  .bigbasket_color
 {
  color:#83c42a;
 }
 .bigbasket_border
 {
   border-right: 2px solid #83c42a!important;
 }
 .bigbasket_bg
 {
    background: url(/img/bbasket.png)!important;
    background-repeat: round!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 } 
 .amazon_bg
 {
    background: url(/img/amazon.png)!important;
    background-repeat: no-repeat!important;
    background-position: center!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 } 
 .amazon_border
 {
  border-right: 2px solid #FF9900!important;
 }
  .amazon_color
 {
  color:#FF9900!important;
 }
 .outofstock
 {
    color:red;
    float:right;
    font-size:12px;
    margin-right:6px
 }

 .flipkart_color
 {
  color:#2874f0;
 }
 .flipkart_border
 {
  border-right: 2px solid #2874f0!important;
 }
 .flipkart_bg
 {
    background: url(/img/flipkart.png)!important;
    background-repeat: round!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 }
</style>